/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_Appearance_TitleInputs */



/**
* | output |
* | --- |
* | "Text appearance" |
*
* @param {Options_Watermark_Appearance_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_appearance_title = /** @type {((inputs?: Options_Watermark_Appearance_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Appearance_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Apparence du texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Textdarstellung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aspetto del testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Оформление текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Apariencia del texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本外观")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストの外観")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट का स्वरूप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aspeto do texto")
	return /** @type {LocalizedString} */ ("Text appearance")
});